import i18next from 'i18next';
const validateRequiredI18n = (value) => (value ? null : i18next.t('validation:required'));
export default validateRequiredI18n;
